!(function(window) {
  const config = { 
    roundingThreshold: 0.5, 
    animationDelay: 200,
    excludedProductTypes: [
      {singular: "Art Print", plural: "Art Prints"},
      {singular: "Gift Card", plural: "Gift Cards"},
      {singular: "Hat", plural: "Hats"}
    ]
  };
      
  const tiers = {
    thresholds: [2, 20, 40, 50, 60, 80, 100, 150, 200],
    labels: {
      2: "Free Shipping",
      20: "A Free Card",
      40: "Another Free Card",
      50: "Free Priority Shipping",
      60: "2 More Free Cards",
      80: "2 More Free Cards",
      100: "10% Off",
      150: "15% Off",
      200: "20% Off"
    },
    simpleLabels: {
      2: "Free Shipping",
      20: "1 Free Card",
      40: "2 Free Cards",
      50: "Free Priority Shipping",
      60: "4 Free Cards",
      80: "6 Free Cards",
      100: "10% Off",
      150: "15% Off",
      200: "20% Off"
    },
    categories: {
      2: "shipping",
      20: "cards",
      40: "cards",
      50: "shipping",
      60: "cards",
      80: "cards",
      100: "discount",
      150: "discount",
      200: "discount"
    },
    cardRewards: { 
      tier1: { threshold: 20 - config.roundingThreshold, cards: 1 }, 
      tier2: { threshold: 40 - config.roundingThreshold, cards: 2 }, 
      tier3: { threshold: 60 - config.roundingThreshold, cards: 4 },
      tier4: { threshold: 80 - config.roundingThreshold, cards: 6 }
    }
  };

  // ===== COOKIE MANAGEMENT (consolidated from jc-promo-display.js) =====
  function setCookie(name, value, days) {
    var date = new Date();
    var time = date.getTime() + (864e5 * days);
    date.setTime(time);
    document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    const cookieString = `; ${document.cookie}`.split(`; ${name}=`);
    if (cookieString.length === 2) return cookieString.pop().split(";").shift();
  }

  // ===== PROMO DISPLAY MANAGEMENT (consolidated from jc-promo-display.js) =====
  function promo_tracker_display(action) {
    const progressTracker = document.getElementsByClassName("progress_tracker")[0];
    const promoDropdown = document.getElementsByClassName("promo-dropdown")[0]; 
    const plusIcon = document.querySelector(".icon-plus");
    const minusIcon = document.querySelector(".icon-minus");
    const promoButton = document.querySelector('.m-collapsible--button.promo-dropdown__trigger');
    const wrapper = document.getElementsByClassName("progress-bar-wrapper")[0];
    
    if (!progressTracker || !promoDropdown || !plusIcon || !minusIcon) return;
    
    // Remove any existing transitions to prevent visual flicker
    progressTracker.style.transition = "none";
    
    if (action === "hide") {
      progressTracker.style.opacity = "0";
      progressTracker.style.maxHeight = "0px";
      progressTracker.style.paddingTop = "0";
      progressTracker.style.paddingBottom = "0";
      promoDropdown.style.marginBottom = "0";
      plusIcon.style.display = "block";
      minusIcon.style.display = "none";
      if (promoButton) promoButton.setAttribute('aria-expanded', 'false');
      if (wrapper) wrapper.classList.remove('promo-expanded');
    } else {
      progressTracker.style.opacity = "1";
      progressTracker.style.maxHeight = "1000px";
      progressTracker.style.paddingTop = "1rem";
      progressTracker.style.paddingBottom = "";
      promoDropdown.style.marginBottom = "";
      plusIcon.style.display = "none";
      minusIcon.style.display = "block";
      if (promoButton) promoButton.setAttribute('aria-expanded', 'true');
      if (wrapper) wrapper.classList.add('promo-expanded');
    }
    
    // Re-enable transitions after a brief delay
    setTimeout(() => {
      if (progressTracker) {
        progressTracker.style.transition = "all 0.15s";
      }
    }, 50);
  }

  function promo_tracker_save() {
    const currentState = getCookie("promo_tracker_hide_status");
    const newState = (currentState === "hide") ? "show" : "hide";
    setCookie("promo_tracker_hide_status", newState, 7);
    promo_tracker_display(newState);
  }

  // New function to sync promo state after cart updates
  function syncPromoState() {
    const cookieState = getCookie("promo_tracker_hide_status");
    if (cookieState) {
      promo_tracker_display(cookieState);
    }
  }

  function promo_tracker_onload() {
    if (typeof window.freeShippingInitialize === 'function') {
      window.freeShippingInitialize();
      const cookieState = getCookie("promo_tracker_hide_status");
      promo_tracker_display(cookieState);
    } else {
      setTimeout(promo_tracker_onload, 100);
    }
  }

  // Make functions globally available (for onclick in template)
  window.promo_tracker_save = promo_tracker_save;
  window.promo_tracker_display = promo_tracker_display;
  window.getCookie = getCookie;
  window.setCookie = setCookie;

  var hasExcludedItems = false;
  var excludedItemTypes = [];
  
  function getCurrentAndNextTier(cartValue) {
    const thresholds = tiers.thresholds;
    const threshold = config.roundingThreshold;
    
    if (cartValue < thresholds[0] - threshold) {
      return [0, thresholds[0], thresholds[1]];
    }
    
    let currentTierIndex = 0;
    for (let i = 0; i < thresholds.length; i++) {
      if (cartValue >= thresholds[i] - threshold) {
        currentTierIndex = i;
      } else {
        break;
      }
    }
    
    if (currentTierIndex >= thresholds.length - 1) {
      return [0, thresholds[currentTierIndex], thresholds[currentTierIndex]];
    }
    
    return [0, thresholds[currentTierIndex], thresholds[currentTierIndex + 1]];
  }
  
  function isFirstTier(cartValue) {
    const firstTier = tiers.thresholds[0];
    return cartValue < firstTier - config.roundingThreshold;
  }
  
  function getHighestUnlockedTiers(cartValue) {
    const unlockedTiers = {};
    const threshold = config.roundingThreshold;
    
    for (let i = 0; i < tiers.thresholds.length; i++) {
      const tierValue = tiers.thresholds[i];
      const category = tiers.categories[tierValue];
      
      if (cartValue >= tierValue - threshold) {
        if (!unlockedTiers[category] || tierValue > unlockedTiers[category]) {
          unlockedTiers[category] = tierValue;
        }
      }
    }
    
    return unlockedTiers;
  }
  
  function getExcludedType(productType) {
    if (!productType) return null;
    
    for (const excludedType of config.excludedProductTypes) {
      if (productType.toLowerCase() === excludedType.singular.toLowerCase()) {
        return excludedType;
      }
    }
    
    return null;
  }
  
  const calculateCartValue = function(cart) {
    var items = cart.items;
    var total = 0;
    hasExcludedItems = false;
    excludedItemTypes = [];
    
    for (let i = 0; i < items.length; i++) {
      if (items[i].product_type) {
        const excludedType = getExcludedType(items[i].product_type);
        if (excludedType) {
          hasExcludedItems = true;
          if (!excludedItemTypes.includes(excludedType.plural)) {
            excludedItemTypes.push(excludedType.plural);
          }
        }
      }
      
      if (items[i].requires_shipping == 1 && items[i].final_price > 0) {
        const excludedType = items[i].product_type ? getExcludedType(items[i].product_type) : null;
        if (!excludedType) {
          total += items[i].final_price * items[i].quantity;
        }
      }
      
      if (items[i].requires_shipping == 0) {
        hasExcludedItems = true;
        const giftCardPlural = "Gift Cards";
        if (!excludedItemTypes.includes(giftCardPlural)) {
          excludedItemTypes.push(giftCardPlural);
        }
      }
    }
    
    return total;
  };
  
  const countFreeCardsInCart = function(cart) {
    var items = cart.items;
    var count = 0;
    
    for (let i = 0; i < items.length; i++) {
      if (items[i].final_price == 0 && items[i].discounts) {
        for (let discount of items[i].discounts) {
          if (discount && discount.title.includes("Free Card")) {
            count += items[i].quantity;
            break;
          }
        }
      }
    }
    
    return count;
  };
  
  const calculateEligibleFreeCards = function(cart, filteredCartTotal) {
    const rewards = tiers.cardRewards;
    const cartTotal = filteredCartTotal;
    
    if (cartTotal >= rewards.tier4.threshold) return rewards.tier4.cards;
    if (cartTotal >= rewards.tier3.threshold) return rewards.tier3.cards;
    if (cartTotal >= rewards.tier2.threshold) return rewards.tier2.cards;
    if (cartTotal >= rewards.tier1.threshold) return rewards.tier1.cards;
    return 0;
  };
  
  function getExclusionMessage() {
    if (!hasExcludedItems || excludedItemTypes.length === 0) {
      return "";
    }
    
    const hasPrintOnDemand = excludedItemTypes.some(type => 
      type === "Art Prints" || type === "Print-on-Demand Items"
    );
    
    if (hasPrintOnDemand && excludedItemTypes.length === 1) {
      return "Art prints ship separately, but free. They do not count towards promos.";
    }
    
    if (hasPrintOnDemand) {
      const otherExcluded = excludedItemTypes.filter(type => 
        type !== "Art Prints" && type !== "Print-on-Demand Items"
      );
      
      let otherExcludedList = "";
      if (otherExcluded.length === 1) {
        otherExcludedList = otherExcluded[0];
      } else if (otherExcluded.length === 2) {
        otherExcludedList = `${otherExcluded[0]} & ${otherExcluded[1]}`;
      } else if (otherExcluded.length > 2) {
        const lastType = otherExcluded.pop();
        otherExcludedList = `${otherExcluded.join(", ")}, & ${lastType}`;
        otherExcluded.push(lastType);
      }
      
      return `Art prints ship separately, but free. ${otherExcludedList} and Art prints do not count towards promos.`;
    }
    
    let excludedTypesList = "";
    
    if (excludedItemTypes.length === 1) {
      excludedTypesList = excludedItemTypes[0];
    } else if (excludedItemTypes.length === 2) {
      excludedTypesList = `${excludedItemTypes[0]} & ${excludedItemTypes[1]}`;
    } else {
      const lastType = excludedItemTypes.pop();
      excludedTypesList = `${excludedItemTypes.join(", ")}, & ${lastType}`;
      excludedItemTypes.push(lastType);
    }
    
    return `Note: ${excludedTypesList} do not count towards promos.`;
  }
  
  const generateSuggestion = function(cart, cartValue) {
    const isSaleActive = (function() {
      const saleStateElem = document.getElementById("progress-sale-state");
      return saleStateElem && saleStateElem.dataset.saleActive === "true";
    })();
    
    if (isSaleActive) {
      return { 
        unlockedItems: [], 
        bottomLine: "" 
      };
    }
    
    var createLink = function(url, text) {
      return `<a href="${url}" style="color: #1772b0; font-weight:normal;">${text}</a>`;
    };
    
    const unlockedTiers = getHighestUnlockedTiers(cartValue);
    const freeCardsInCart = countFreeCardsInCart(cart);
    const freeCards = calculateEligibleFreeCards(cart, cartValue);
    
    const unlockedItems = [];
    for (const category in unlockedTiers) {
      const tierValue = unlockedTiers[category];
      let itemText = `✅ ${tiers.simpleLabels[tierValue]}`;
      
      if (category === 'cards' && freeCards > freeCardsInCart && cartValue >= tiers.cardRewards.tier1.threshold) {
        const missingCards = freeCards - freeCardsInCart;
        const claimableCards = Math.min(missingCards, freeCards);
        
        // Updated link text to show quantity when more than 1
        let linkText = "";
        if (missingCards > 0) {
          linkText = `Add ${missingCards} to cart to claim`;
        }
        
        const claimLink = createLink("/collections/cards", linkText);
        itemText += ` - ${claimLink}`;
      }
      
      unlockedItems.push(itemText);
    }
    
    const tierValues = getCurrentAndNextTier(cartValue);
    const currentTier = tierValues[1];
    const nextTier = tierValues[2];
    
    let nextTierName = "";
    let amountToNextTier = 0;
    let lastTierValue = 0;
    
    for (let i = 0; i < tiers.thresholds.length; i++) {
      if (cartValue < tiers.thresholds[i] - config.roundingThreshold) {
        nextTierName = tiers.labels[tiers.thresholds[i]].toLowerCase();
        amountToNextTier = tiers.thresholds[i] - cartValue;
        lastTierValue = i > 0 ? tiers.thresholds[i-1] : 0;
        break;
      }
    }

    let bottomLine = "";
    
    const allItemsExcluded = hasExcludedItems && cartValue <= 0.001;
    const onlyPrintOnDemandItems = (excludedItemTypes.length === 1 && 
      (excludedItemTypes[0] === "Art Prints" || excludedItemTypes[0] === "Print-on-Demand Items"));
    
    let exclusionMessage = "";
    if (hasExcludedItems) {
      if (allItemsExcluded && onlyPrintOnDemandItems) {
        exclusionMessage = "Art prints ship separately, but free. They do not count towards promos.";
      } else {
        exclusionMessage = getExclusionMessage();
      }
    }
    
    const isAtFirstTier = cartValue < tiers.thresholds[0] - config.roundingThreshold;
    
    let nextTierMessage = "";
    
    if (allItemsExcluded) {
      if (onlyPrintOnDemandItems) {
        nextTierMessage = ``;
      } else {
        let nextTierNameDisplay = `<b>${tiers.labels[tiers.thresholds[0]].toLowerCase()}</b>`;
        nextTierMessage = `Add $${Math.max(1, Math.ceil(tiers.thresholds[0] - 0.5))} in eligible items for ${nextTierNameDisplay}.`;
      }
    }
    else if (freeCards > freeCardsInCart) {
      if (nextTier > currentTier && amountToNextTier > config.roundingThreshold) {
        let nextTierNameDisplay = `<b>${nextTierName}</b>`;
        
        if (isAtFirstTier) {
          nextTierMessage = `Just $${Math.max(1, Math.ceil(amountToNextTier - 0.5))} away from ${nextTierNameDisplay}.`;
        } else {
          nextTierMessage = `Just $${Math.max(1, Math.ceil(amountToNextTier - 0.5))} away from ${nextTierNameDisplay}.`;
        }
      }
    }
    else if (Math.ceil(cartValue) >= 200) {
      nextTierMessage = "Maximum promo level reached, you absolute legend.";
    }
    else if (currentTier > 0 && nextTier > currentTier && amountToNextTier > config.roundingThreshold) {
      let nextTierNameDisplay = `<b>${nextTierName}</b>`;
      
      if (isAtFirstTier) {
        nextTierMessage = `Just $${Math.max(1, Math.ceil(amountToNextTier - 0.5))} away from ${nextTierNameDisplay}.`;
      } else {
        nextTierMessage = `Just $${Math.max(1, Math.ceil(amountToNextTier - 0.5))} away from ${nextTierNameDisplay}.`;
      }
    }
    else if (amountToNextTier > config.roundingThreshold) {
      let nextTierNameDisplay = `<b>${nextTierName}</b>`;
      
      if (isAtFirstTier) {
        nextTierMessage = `Just $${Math.max(1, Math.ceil(amountToNextTier - 0.5))} away from ${nextTierNameDisplay}.`;
      } else {
        nextTierMessage = `Just $${Math.max(1, Math.ceil(amountToNextTier - 0.5))} away from ${nextTierNameDisplay}.`;
      }
    }
    
    if (exclusionMessage && nextTierMessage) {
      bottomLine = nextTierMessage + "<br><br>" + exclusionMessage;
    } else if (exclusionMessage) {
      bottomLine = exclusionMessage;
    } else {
      bottomLine = nextTierMessage;
    }
    
    return { unlockedItems, bottomLine };
  };
  
  const updateDisplay = function(cart) {
    const subtotal = calculateCartValue(cart) / 100;
    const suggestion = generateSuggestion(cart, subtotal);
    
    const wrapper = document.getElementsByClassName("progress-bar-wrapper")[0];
    if (!wrapper) return;
    
    // Clear existing progress content but preserve wrapper structure
    const existingLines = wrapper.querySelectorAll('.cart-progress-unlocked-line, .cart-progress-middle-line, .cart-progress-bottom-line');
    existingLines.forEach(line => line.remove());
    
    // Add new content without touching wrapper classes or innerHTML
    if (suggestion.unlockedItems && suggestion.unlockedItems.length > 0) {
      for (let i = 0; i < suggestion.unlockedItems.length; i++) {
        const lineElem = document.createElement("div");
        lineElem.classList.add("cart-progress-unlocked-line");
        lineElem.style.fontWeight = 'bold';
        lineElem.style.marginBottom = '4px';
        lineElem.innerHTML = suggestion.unlockedItems[i];
        wrapper.appendChild(lineElem);
      }
    }
    
    if (suggestion.bottomLine) {
      const bottomLineElem = document.createElement("div");
      bottomLineElem.classList.add("cart-progress-bottom-line");
      bottomLineElem.innerHTML = suggestion.bottomLine;
      wrapper.appendChild(bottomLineElem);
    }

    wrapper.style.textAlign = 'center';
    
    // IMPORTANT: Sync promo state after updating display
    // This ensures the collapse/expand state matches the cookie
    setTimeout(() => {
      syncPromoState();
    }, 10);
  };
  
  function initialize() {
    hasExcludedItems = false;
    
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((cart) => {
        updateDisplay(cart);
      })
      .catch(error => {
        console.error("Error fetching cart:", error);
      });
  }
  
  const updateCart = function(prevCartValue) {
    hasExcludedItems = false;
    
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((cart) => {
        updateDisplay(cart);
      })
      .catch(error => {
        console.error("Error updating cart:", error);
      });
  };

  window.freeShippingInitialize = initialize;
  window.freeShippingUpdate = updateCart;

  document.addEventListener('DOMContentLoaded', function() {
    const checkForPubSub = setInterval(() => {
      if (typeof window.PUB_SUB_EVENTS !== 'undefined' && typeof window.subscribe === 'function') {
        clearInterval(checkForPubSub);
        
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(event) {
          setTimeout(() => {
            if (event.cartData) {
              updateDisplay(event.cartData);
            } else {
              updateCart();
            }
          }, 10);
        });
      }
    }, 100);
  });
  
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      updateDisplay(event.detail.cart);
    } else {
      updateCart();
    }
  });
  
  const originalFetch = window.fetch;
  window.fetch = function() {
    const result = originalFetch.apply(this, arguments);
    const url = arguments[0]?.toString() || '';
    
    if (url.includes('/cart/add') || 
        url.includes('/cart/update') || 
        url.includes('/cart/change') || 
        url.includes('/cart/clear')) {
      
      result.then(() => {
        updateCart();
      });
    }
    
    return result;
  };
  
  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Run promo onload after everything is set up
  setTimeout(promo_tracker_onload, 100);
})(window);